import { render, staticRenderFns } from "./pre_index.vue?vue&type=template&id=7a486239&scoped=true&"
import script from "./pre_index.vue?vue&type=script&lang=ts&"
export * from "./pre_index.vue?vue&type=script&lang=ts&"
import style0 from "./pre_index.vue?vue&type=style&index=0&id=7a486239&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a486239",
  null
  
)

export default component.exports